import { Menu, MenuItem } from '@mui/material';

export interface MenuListingProps {
  downloadAnchor: HTMLElement | null;
  openDownload: boolean;
  handleCloseDownloadOptions: () => void;
  onClickDownload: (type: string) => void;
}

const MenuListing = ({
  downloadAnchor,
  openDownload,
  handleCloseDownloadOptions,
  onClickDownload,
}: MenuListingProps) => {
  return (
    <Menu anchorEl={downloadAnchor} open={openDownload} onClose={handleCloseDownloadOptions}>
      <MenuItem onClick={() => onClickDownload('csv')}>Download as CSV</MenuItem>
      <MenuItem onClick={() => onClickDownload('xls')}>Download as XLS</MenuItem>
    </Menu>
  );
};
export default MenuListing;
